import React, { useState, useEffect } from 'react'
import {
  Grid,
  GridCell,
  Flex,
  Title,
  SpacingVertical,
  FormElement,
  InputNumber,
  Text,
  Divider
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import iconBorder from '../../icons/cd-icon-borders.svg'
import styled from '@emotion/styled'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import {
  defaultStyleState,
  pageState,
  styleState
} from 'Pages/EmailContentDefaults/recoil/state/state'
import BorderStyleSelect from 'Pages/EmailContentDefaults/shared/BorderStyleSelect'
import { isNumber } from 'Pages/EmailContentDefaults/shared/utils'

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding-right: 8px;
`

const StyledInputNumber = styled(InputNumber)`
  margin-right: 8px;
`

const StyleGrid = styled(Grid)`
  margin: 0 12px;
`

const ButtonBorder = () => {
  const intl = useIntl()
  const { button } = useRecoilValue(styleState)
  const { button: defaultButton } = useRecoilValue(defaultStyleState)
  const { isEnabled } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)
  const setStyleState = useSetRecoilState(styleState)

  const [borderSize, setBorderSize] = useState(
    +button.styles.borderBottom.split(' ')[0].replace('px', '')
  )

  const [borderStyle, setBorderStyle] = useState(
    button.styles.borderBottom.split(' ')[1]
  )

  useEffect(() => {
    const valBorderSize = isNumber(borderSize)
      ? borderSize + 'px'
      : defaultButton.styles.borderBottom.split(' ')[0]
    const valBorderStyle =
      borderStyle || defaultButton.styles.borderBottom.split(' ')[1]

    const borderBottom = button.styles.borderBottom.split(' ')
    borderBottom[0] = valBorderSize
    borderBottom[1] = valBorderStyle
    const borderTop = button.styles.borderBottom.split(' ')
    borderTop[0] = valBorderSize
    borderTop[1] = valBorderStyle
    const borderLeft = button.styles.borderBottom.split(' ')
    borderLeft[0] = valBorderSize
    borderLeft[1] = valBorderStyle
    const borderRight = button.styles.borderBottom.split(' ')
    borderRight[0] = valBorderSize
    borderRight[1] = valBorderStyle
    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          borderBottom: borderBottom.join(' '),
          borderTop: borderTop.join(' '),
          borderLeft: borderLeft.join(' '),
          borderRight: borderRight.join(' ')
        }
      }
    }))
  }, [borderSize, borderStyle])

  const onChangeBorderRadius = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setStyleState(prev => ({
      ...prev,
      button: {
        ...prev.button,
        styles: {
          ...prev.button.styles,
          borderRadius: isNumber(value)
            ? value + 'px'
            : defaultButton.styles.borderRadius
        }
      }
    }))
  }

  const onChangeBorderSize = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setBorderSize(value)
  }

  const onChangeBorderStyle = value => {
    setPageState(prev => ({
      ...prev,
      isDirty: true
    }))

    setBorderStyle(value)
  }

  return (
    <>
      <Flex alignItems='center'>
        <StyledIcon src={iconBorder} />
        <Title variant='M'>
          {intl.formatMessage({
            id: 'Load.ContentDefaults.CommonBordersTitle'
          })}
        </Title>
      </Flex>
      <SpacingVertical variant='16' />
      <StyleGrid>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.BorderRadiusLabel'
            })}
          >
            <Flex alignItems='center'>
              <StyledInputNumber
                min={0}
                value={parseInt(button.styles.borderRadius.slice(0, -2))}
                onChange={onChangeBorderRadius}
                disabled={!isEnabled}
              />
              <Text>px</Text>
            </Flex>
          </FormElement>
        </GridCell>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.BorderSizeLabel'
            })}
          >
            <Flex alignItems='center'>
              <StyledInputNumber
                min={0}
                value={parseInt(
                  button.styles.borderBottom.split(' ')[0].slice(0, -2)
                )}
                onChange={onChangeBorderSize}
                disabled={!isEnabled}
              />
              <Text>px</Text>
            </Flex>
          </FormElement>
        </GridCell>
        <GridCell>
          <FormElement
            label={intl.formatMessage({
              id: 'Load.ContentDefaults.BorderStyleLabel'
            })}
          >
            <BorderStyleSelect
              value={button.styles.borderBottom.split(' ')[1]}
              onChange={onChangeBorderStyle}
              disabled={!isEnabled}
            />
          </FormElement>
        </GridCell>
      </StyleGrid>
      <SpacingVertical />
      <Divider />
      <SpacingVertical />
    </>
  )
}

export default ButtonBorder
